// isEnum returns a function that checks if a value is a key of a a given enum
export function isEnum<T extends string, TEnumValue>(enumVariable: {
  [key in T]: TEnumValue;
}) {
  return (value: string): value is T => Object.values(enumVariable).includes(value);
}
